import React, { FC } from 'react';

import { TToolTipProps } from './ToolTip.types';

import SToolTip from './ToolTip.style';

const ToolTip: FC<TToolTipProps> = props => {
  return <SToolTip {...props} />;
};

export default ToolTip;
